export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["BIAB004"] = "biab-004";
  ExperimentKeys["ACQ128"] = "acq-128";
  ExperimentKeys["ACQ133"] = "acq-0133";
  ExperimentKeys["GOSU025B"] = "gosu-025b";
  ExperimentKeys["GOSU0001"] = "gosu-0001";
  ExperimentKeys["GOSU0002"] = "gosu-0002";
  ExperimentKeys["ACQ136"] = "acq-0136";
  ExperimentKeys["ACQ0137"] = "acqci-acq-0137";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';